
import { Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { grid_gridCols2, md, backgroundColor_bgPrimary700, backgroundColor_bgPrimary600, textColor_textOnPrimary, textColor_textNeutral900, textColor_textNeutral500, textColor_textPrimary700, hover, textColor_textNeutral700, textColor_textPrimary600, textColor_textSuccess600, textColor_textNeutral600, textColor_textWarning800, backgroundColor_bgPrimary50, backgroundColor_bgSuccess50, backgroundColor_bgWarning50 } from "../TailwindExtensions.js";
import { margin_mt4, gap_gap$002D4, display_grid, margin_mb4, padding_p6, padding_p4, cursor_cursorNotAllowed, opacity_opacity50, borderRadius_roundedMd, padding_py2, padding_px4, gap_gap$002D2, fontWeight_fontBold, fontSize_textXl, margin_mt2, margin_mt3, margin_mt1, textDecoration_underline, fontWeight_fontMedium, display_inlineFlex, fontSize_textSm, fontWeight_fontSemibold, fontSize_textLg, margin_mb3, alignItems_itemsCenter, display_flex, tw, backgroundColor_bgNeutral50 } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { IconWeight, IconSize, icon, IconName } from "../Icons.js";
import { printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { toString } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { PledgeCalculation_calculateDonationEstimate, PledgeCalculation_cappedUnits } from "../Pledge.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { createElement } from "react";
import { UnitName_singular } from "../Challenge.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";

/**
 * The six pledge status card variants for the challenge detail page
 */
export class StatusCardVariant extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ActivePledge", "DonationDue", "NoDonationDue", "Donated", "ChallengeCancelled", "SelfAbandoned"];
    }
}

export function StatusCardVariant_$reflection() {
    return union_type("Shared.PledgeStatusCard.StatusCardVariant", [], StatusCardVariant, () => [[], [], [], [], [], []]);
}

/**
 * Classify a pledge summary into a status card variant
 */
export function classifyStatusCard(pledge) {
    const matchValue = pledge.Status;
    switch (matchValue) {
        case "paid":
            return new StatusCardVariant(3, []);
        case "no_donation_due":
            return new StatusCardVariant(2, []);
        case "cancelled":
            return new StatusCardVariant(5, []);
        case "abandoned":
            return new StatusCardVariant(5, []);
        case "active": {
            const matchValue_1 = pledge.Challenge.ChallengeStatus;
            switch (matchValue_1) {
                case "published":
                case "pledged":
                case "active":
                    return new StatusCardVariant(0, []);
                case "finalizing":
                case "finalized":
                    return new StatusCardVariant(1, []);
                case "abandoned":
                    return new StatusCardVariant(4, []);
                default:
                    return undefined;
            }
        }
        default:
            return undefined;
    }
}

/**
 * Get the heading text for a status card variant
 */
export function cardHeading(variant) {
    switch (variant.tag) {
        case 1:
            return "Donation due";
        case 2:
            return "No donation due";
        case 3:
            return "Donated";
        case 4:
            return "Challenge cancelled";
        case 5:
            return "Pledge abandoned";
        default:
            return "You\'re supporting this";
    }
}

/**
 * Get the left border color class for a status card variant
 */
export function cardBorderClass(variant) {
    switch (variant.tag) {
        case 1:
            return "border-warning-300";
        case 2:
            return "border-neutral-400";
        case 3:
            return "border-success-600";
        case 4:
            return "border-neutral-400";
        case 5:
            return "border-neutral-400";
        default:
            return "border-primary-600";
    }
}

function cardBgClass(variant) {
    switch (variant.tag) {
        case 1:
            return backgroundColor_bgWarning50;
        case 2:
            return backgroundColor_bgNeutral50;
        case 3:
            return backgroundColor_bgSuccess50;
        case 4:
            return backgroundColor_bgNeutral50;
        case 5:
            return backgroundColor_bgNeutral50;
        default:
            return backgroundColor_bgPrimary50;
    }
}

function headerColorClass(variant) {
    switch (variant.tag) {
        case 1:
            return textColor_textWarning800;
        case 2:
            return textColor_textNeutral600;
        case 3:
            return textColor_textSuccess600;
        case 4:
            return textColor_textNeutral600;
        case 5:
            return textColor_textNeutral600;
        default:
            return textColor_textPrimary600;
    }
}

/**
 * Get the icon for a status card variant (same icons as PledgeIndicatorBadge)
 */
export function cardIcon(variant) {
    switch (variant.tag) {
        case 1:
            return new IconName(34, []);
        case 2:
            return new IconName(32, []);
        case 3:
            return new IconName(32, []);
        case 4:
            return new IconName(7, []);
        case 5:
            return new IconName(7, []);
        default:
            return new IconName(3, []);
    }
}

/**
 * Build the href for a pledge detail link
 */
export function pledgeLinkHref(pledgeId) {
    return toText(printf("/pledges/%s"))(pledgeId);
}

function formatCurrency(amount) {
    return toText(printf("$%.2f"))(amount);
}

function formatDate(date) {
    return toString(date, "MMM d, yyyy");
}

/**
 * Get the donation calculation text (e.g. "$5.00 x 87 miles")
 */
export function donationCalculationText(pledge) {
    const units = PledgeCalculation_cappedUnits(pledge.GoalUnitsAtPledge, pledge.Challenge.UnitsCompleted, pledge.CapAtGoal);
    const arg = formatCurrency(pledge.AmountPerUnit);
    return toText(printf("%s x %.0f %s"))(arg)(units)(pledge.Challenge.UnitName);
}

function cardHeader(variant) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-2", margin_mb3]))], ["children", [createElement(icon, {
        name: cardIcon(variant),
        size: new IconSize(1, []),
        weight: new IconWeight(1, []),
    }), HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, headerColorClass(variant)]))], ["children", singleton(cardHeading(variant))]]))]]]));
}

function infoRow(iconName, text) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", fontSize_textSm, textColor_textNeutral700]))], ["children", [createElement(icon, {
        name: iconName,
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton(text)]))]]]));
}

function pledgeDetailLink(pledgeId, text, onNavigate) {
    return HtmlHelper_createElement("a", ofArray([["href", pledgeLinkHref(pledgeId)], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, "gap-1.5", fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), hover(textDecoration_underline)]))], ["onClick", (e) => {
        e.preventDefault();
        onNavigate(pledgeId);
    }], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton(text)])), createElement(icon, {
        name: new IconName(38, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })]]]));
}

function activePledgeContent(pledge, onNavigate) {
    let arg, arg_2, arg_3, arg_4;
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    const maxDonation = PledgeCalculation_calculateDonationEstimate(pledge.AmountPerUnit, pledge.GoalUnitsAtPledge, pledge.Challenge.UnitsCompleted, pledge.CapAtGoal);
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [infoRow(new IconName(42, []), (arg = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge: %s per %s"))(arg)(unit))), infoRow(new IconName(17, []), (arg_2 = (pledge.CapAtGoal ? "Yes" : "No"), toText(printf("Cap at goal: %s"))(arg_2))), infoRow(new IconName(42, []), (arg_3 = formatCurrency(maxDonation), toText(printf("Max donation: %s"))(arg_3))), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton((arg_4 = formatDate(pledge.CreatedAt), toText(printf("Pledged: %s"))(arg_4)))]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "Manage your pledge", onNavigate)]]]))]]]));
}

function donationDueContent(pledge, onNavigate) {
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    const donationAmount = PledgeCalculation_calculateDonationEstimate(pledge.AmountPerUnit, pledge.GoalUnitsAtPledge, pledge.Challenge.UnitsCompleted, pledge.CapAtGoal);
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", toList(delay(() => {
        let arg;
        return append(singleton_1(infoRow(new IconName(42, []), (arg = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge: %s per %s"))(arg)(unit)))), delay(() => {
            let arg_2;
            return append(singleton_1(infoRow(new IconName(17, []), (arg_2 = (pledge.CapAtGoal ? "Yes" : "No"), toText(printf("Cap at goal: %s"))(arg_2)))), delay(() => {
                let arg_3;
                return append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mt2))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton("Your donation amount:")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textXl, fontWeight_fontBold, textColor_textNeutral900, margin_mt1]))], ["children", singleton(formatCurrency(donationAmount))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_3 = donationCalculationText(pledge), toText(printf("(%s)"))(arg_3)))]]))]]]))), delay(() => {
                    let matchValue;
                    return append((matchValue = pledge.DonateLink, (matchValue == null) ? singleton_1(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, padding_px4, padding_py2, fontSize_textSm, fontWeight_fontMedium, textColor_textOnPrimary, backgroundColor_bgPrimary600, borderRadius_roundedMd, opacity_opacity50, cursor_cursorNotAllowed, margin_mt3]))], ["disabled", true], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton("Donate via Every.org")])), createElement(icon, {
                        name: new IconName(48, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    })]]]))) : singleton_1(HtmlHelper_createElement("a", ofArray([["href", matchValue], ["target", "_blank"], ["rel", "noopener noreferrer"], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, padding_px4, padding_py2, fontSize_textSm, fontWeight_fontMedium, textColor_textOnPrimary, backgroundColor_bgPrimary600, borderRadius_roundedMd, hover(backgroundColor_bgPrimary700), margin_mt3]))], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton("Donate via Every.org")])), createElement(icon, {
                        name: new IconName(48, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    })]]])))), delay(() => append((pledge.DonateLink == null) ? singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600, margin_mt2]))], ["children", singleton("Your donation link is being prepared. Check back soon.")]]))) : singleton_1(defaultOf()), delay(() => singleton_1(HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "View pledge details", onNavigate)]]])))))));
                }));
            }));
        }));
    }))]]));
}

function donatedContent(pledge, onNavigate) {
    let arg, arg_2, arg_3, arg_4;
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    const donationAmount = defaultArg(pledge.PledgedAmount, PledgeCalculation_calculateDonationEstimate(pledge.AmountPerUnit, pledge.Challenge.GoalUnits, pledge.Challenge.UnitsCompleted, pledge.CapAtGoal));
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [infoRow(new IconName(42, []), (arg = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge: %s per %s"))(arg)(unit))), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700]))], ["children", singleton((arg_2 = formatCurrency(donationAmount), toText(printf("You donated: %s"))(arg_2)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_3 = donationCalculationText(pledge), toText(printf("(%s)"))(arg_3)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton((arg_4 = formatDate(pledge.CreatedAt), toText(printf("Pledged: %s"))(arg_4)))]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "View pledge details", onNavigate)]]]))]]]));
}

function challengeCancelledContent(pledge, onNavigate) {
    let arg, arg_2;
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700]))], ["children", singleton("This challenge was cancelled by the host. Your pledge has been voided — no donation owed.")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700, margin_mt2]))], ["children", singleton((arg = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge was: %s/%s"))(arg)(unit)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_2 = formatDate(pledge.CreatedAt), toText(printf("Pledged: %s"))(arg_2)))]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "View pledge details", onNavigate)]]]))]]]));
}

function noDonationDueContent(pledge, onNavigate) {
    let value_4, arg, arg_2;
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700]))], (value_4 = "This challenge finished without enough progress at your pledge rate for a donation, so no donation is owed.", ["children", singleton(value_4)])])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700, margin_mt2]))], ["children", singleton((arg = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge was: %s/%s"))(arg)(unit)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_2 = formatDate(pledge.CreatedAt), toText(printf("Pledged: %s"))(arg_2)))]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "View pledge details", onNavigate)]]]))]]]));
}

function selfAbandonedContent(pledge, onNavigate) {
    let arg, arg_1, arg_3;
    const unit = UnitName_singular(pledge.Challenge.UnitName);
    const abandonedAt = (pledge.Status === "abandoned") ? pledge.AbandonedAt : pledge.CancelledAt;
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700]))], ["children", singleton((arg = ((abandonedAt == null) ? "an unknown date" : formatDate(abandonedAt)), toText(printf("You abandoned this pledge on %s."))(arg)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral700, margin_mt2]))], ["children", singleton((arg_1 = formatCurrency(pledge.AmountPerUnit), toText(printf("Your pledge was: %s/%s"))(arg_1)(unit)))]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_3 = formatDate(pledge.CreatedAt), toText(printf("Pledged: %s"))(arg_3)))]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt3], ["children", [pledgeDetailLink(pledge.PledgeId, "View pledge details", onNavigate)]]]))]]]));
}

/**
 * Render the PledgeStatusCard. Returns Html.none if pledge is None or unclassifiable.
 * activePledgeShare is rendered below the variant content for the ActivePledge variant only.
 * onNavigate is called with the pledge ID string when a detail link is clicked (SPA navigation).
 */
export function pledgeStatusCard(pledge, activePledgeShare, onNavigate) {
    if (pledge != null) {
        const p = pledge;
        const matchValue = classifyStatusCard(p);
        if (matchValue != null) {
            const variant = matchValue;
            return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([cardBgClass(variant), "border-l-4", cardBorderClass(variant), borderRadius_roundedMd, padding_p4, md(padding_p6), margin_mb4]))], ["children", toList(delay(() => append(singleton_1(cardHeader(variant)), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, md(grid_gridCols2), gap_gap$002D4]))], ["children", toList(delay(() => ((variant.tag === 1) ? singleton_1(donationDueContent(p, onNavigate)) : ((variant.tag === 2) ? singleton_1(noDonationDueContent(p, onNavigate)) : ((variant.tag === 3) ? singleton_1(donatedContent(p, onNavigate)) : ((variant.tag === 4) ? singleton_1(challengeCancelledContent(p, onNavigate)) : ((variant.tag === 5) ? singleton_1(selfAbandonedContent(p, onNavigate)) : singleton_1(activePledgeContent(p, onNavigate)))))))))]]))), delay(() => (equals(variant, new StatusCardVariant(0, [])) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", margin_mt4], ["children", [activePledgeShare]]]))) : empty())))))))]]));
        }
        else {
            return defaultOf();
        }
    }
    else {
        return defaultOf();
    }
}

//# sourceMappingURL=PledgeStatusCard.js.map
